import groq from 'groq';

import { COALESCING_PRODUCT_VARIANT } from './coalescingProductVariant';
import { PRODUCT_MEDIA } from './productMedia';
import { PRODUCT_SLUG } from './productSlug';
import { PROMO_CODE_BLOCK_OR_PARENT } from './promoCode';

export const PRODUCT_BUNDLE_IN_BLOCK = groq`
  isMediaDisplayRight,
  title,
  description,
  "media": media[] { ${PRODUCT_MEDIA} },
  "products": products[] {
    product -> {
      ${PRODUCT_SLUG},
      disclaimer
    },
    ${COALESCING_PRODUCT_VARIANT}
  },
  ctaType,
  productBullet,
  secondaryProductBullet,
  "promoCodes": ${PROMO_CODE_BLOCK_OR_PARENT},
  "isPromoCodeVisible": coalesce(isPromoCodeVisible, true)
`;
